import { defineMessages } from "react-intl";

import { useParsedFieldProps } from "./useParsedFieldProps";
import { THEMES } from "../SchemaTypes";
import Field from "../Field";
import TreeMultiSelectInput from "../../Input/TreeMultiSelectInput";
import { useFormatMessage } from "../../Intl/Context";

const ThemesField = props => {
  const { fieldProps, inputProps } = useParsedFieldProps(props);
  const { required, parent, maxSelectedOptions } = props;

  const t = useFormatMessage();
  const tooLongMessage = t(intlMessages.tooLongMessage, {
    count: maxSelectedOptions
  });
  const addButtonLabel = t(intlMessages.addButtonLabel);

  const multiAnswers = maxSelectedOptions > 1;

  const lengthValidation = multiAnswers && {
    maximum: maxSelectedOptions,
    tooLongMessage: tooLongMessage
  };

  const schema = {
    type: THEMES,
    parent,
    validations: {
      required,
      length: lengthValidation
    }
  };

  return (
    <Field {...fieldProps} schema={schema}>
      <TreeMultiSelectInput
        {...inputProps}
        required={required}
        addButtonLabel={addButtonLabel}
        // Disable search in select options as the number of options is not expected to be
        // high enough to require it, and it makes clicking on the component open the
        // keyboard on mobile, which is confusing.
        selectOptions={{ isSearchable: false }}
      />
    </Field>
  );
};

export default ThemesField;

const intlMessages = defineMessages({
  tooLongMessage: {
    id: "answers.themes.error.tooLongMessage",
    defaultMessage: "Merci de sélectionner au maximum {count} thématique(s)."
  },
  addButtonLabel: {
    id: "answers.themes.addButtonLabel",
    defaultMessage: "Ajouter une thématique"
  }
});
